module.exports = __webpack_public_path__ + "media/applicants/img-shopper-header-993626f3.jpg";